<ng-container *ngIf="isLoading$ | async; else content">
  <span class="spinner-grow text-primary load m-5" role="status" data-test-id="loading-spinner"></span>
</ng-container>

<ng-template #content> <ng-content></ng-content> </ng-template>
